import { render, staticRenderFns } from "./gst3bdetailed.vue?vue&type=template&id=d2b2661c&scoped=true"
import script from "./gst3bdetailed.vue?vue&type=script&lang=js"
export * from "./gst3bdetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b2661c",
  null
  
)

export default component.exports